<template>
  <div class="registrationPageBig" style="background: #f4f4f4">
    <!-- <div class="headerDiv">
      <div class="fh"><van-icon @click="fh" name="arrow-left" /></div>
      <div>报名页</div>
    </div> -->
    <div v-if="isShow" class="tipsSuccess">报名成功！</div>
    <div v-if="isSuccess" class="tips">
      填写报名信息后，点击下方“提交报名”按钮
    </div>
    <div v-if="isSuccessful" class="tipsFail">
      报名失败！<br />
      点击“确定”重新提交报名信息
    </div>
    <div class="main">
      <p>
        <a class="titleDiv">姓名</a>
        <input
          class="inputs"
          type="text"
          v-model.trim="form.name"
          :disabled="disableds"
          placeholder="请输入"
        />
      </p>
      <p>
        <a class="titleDiv">手机号</a>
        <input
          class="inputs"
          type="text"
          v-model.trim="form.phone"
          :disabled="disableds"
          placeholder="请输入"
        />
      </p>
      <p>
        <a class="titleDiv">身份证号</a>
        <input
          class="inputs"
          type="text"
          v-model.trim="form.idCard"
          :disabled="disableds"
          placeholder="请输入"
        />
      </p>
      <p>
        <a class="titleDiv">行业类别</a>
        <select
          class="selectChecd"
          v-model="form.industryType"
          placeholder="请输入"
          :disabled="disableds"
        >
          <option
            :disabled="disableds"
            placeholder="请输入"
            v-for="(item, index) in industryTypeOption"
            :key="index"
            :value="item.id"
          >
            {{ item.name }}
          </option>
        </select>
      </p>
      <p v-show="flag" style="font-size: 0.24rem; margin-bottom: 0">
        提示：请输入正确的 {{ contentText }}
      </p>
    </div>

    <div class="btnDiv">
      <div v-if="isSuccess">
        <div class="btn" @click="sub">提交报名</div>
        <div class="btn" @click="seach">去查询</div>
        
      </div>
      <div v-if="isSuccessful" @click="sub" class="determineBtn">确定</div>
      <div v-if="isShow" @click="fh" class="determineBtn">确定</div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import { Icon } from "vant";

export default {
  components: {
    [Icon.name]: Icon,
  },
  data() {
    return {
      isSuccess: true,
      isSuccessful: false,
      isShow: false,
      flag: false,
      disableds: false,
      form: {
        industryType: "",
        phone: "",
        idCard: "",
        name: "",
      },
      industryTypeOption: [
        {
          id: "1",
          name: "2",
        },
      ],
      contentText: "于海拔卡就是",
    };
  },
  created() {
    this.listForIndustryType();
    this.form.name = window.JSON.parse(window.sessionStorage.getItem('thirdRealName'));
    this.form.idCard = window.JSON.parse(window.sessionStorage.getItem('thirdIdCard'));
    this.form.phone = window.JSON.parse(window.sessionStorage.getItem('thirdMobilePhone'));
  },
  methods: {
    listForIndustryType() {
      let _this = this;
      let urls = Global.env + Global.apiCore.listForIndustryType;
      return new Promise((resolve, reject) => {
        request({
          url: urls,
          method: "post",
        })
          .then((response) => {
            this.industryTypeOption = response.data;
          })
          .catch((error) => {});
      });
    },
    fh() {
      this.$router.push({
        name: "Registration",
        query: {},
      });
    },

    sub() {
		 let _this = this;
		 if(_this.form.name == ''){
			this.contentText = "姓名"
			 _this.flag = true;
			 setTimeout(function(){
				 _this.flag = false;
			 },2000)
			   return;
		 }else{
			 _this.flag = false
		 }
		if(!(/^1[3456789]\d{9}$/.test(_this.form.phone))){
			 this.contentText = "手机号"
			 this.flag = true;
			 setTimeout(function(){
				 _this.flag = false;
			 },2000)
			   return;
			}else{
			 _this.flag = false
		 }
		 if(!(/^\d{15}|\d{18}$/.test(_this.form.idCard))){
			 this.contentText = "身份证"
			 this.flag = true;
			 setTimeout(function(){
				 _this.flag = false;
			 },2000)
			   return;
			}else{
			 _this.flag = false
		 }
		 if(_this.form.industryType == ''){
			this.contentText = "行业类别"
			 _this.flag = true;
			 setTimeout(function(){
				 _this.flag = false;
			 },2000)
			   return;
		 }else{
			 _this.flag = false
		 }

		  
      let urls = Global.env + Global.apiCore.signUp;
      return new Promise((resolve, reject) => {
        request({
          url: urls,
          method: "post",
          data: this.form,
        })
          .then((response) => {
            if (response.resultCode == "1000") {
            //   this.isShow = true;
            //   this.isSuccess = false;
            //   this.disableds = true;
			  this.$router.push({
				name: "QrCode",
				query: {},
      });
            }
          })
          .catch((error) => {
            this.isSuccessful = true;
            this.isSuccess = false;
            this.disableds = false;
            // Dialog.alert({
            // 	message: error.errmsg
            // }).then(() => {
            // 	// on close
            // });
            // return reject(error);
          });
      });
    },
    seach() {
      this.$router.push({
        name: "ToQuery",
        query: {},
      });
    },
  },
};
</script>

<style  scoped>
.selectChecd {
  width: 100%;
  /* border: none;
	background: none;
	background: #f8f8f8;
	border: 1px solid #eee;
	font-size: 0.28rem; */
  height: 0.78rem;
  border: none;
  /* outline: none; */
  /* height: 40px;
  line-height: 40px; */
  /* appearance: none;
  background: none;
  -webkit-appearance: none; */
  font-size: 0.28rem;
  border: 1px solid #eee;
  /* -moz-appearance: none; */
  background: #f8f8f8;
}
.registrationBig {
  overflow: hidden;
  height: 100%;
}
.headerDiv {
  position: relative;
  height: 0.7rem;
  text-align: center;
  line-height: 0.7rem;
  font-size: 0.26rem;
  border-bottom: 1px solid #eeeeee;
}
.fh {
  position: absolute;
  left: 0.1rem;
  top: 50%;
  transform: translate(0, -50%);
}
.main {
  width: 100%;
  margin: 0 auto;
  font-size: 0.3rem;
  line-height: 0.52rem;
  font-weight: 400;
  background: #fff;
  padding: 3% 7%;
  /* margin-top: 0.2rem; */
  margin-bottom: 0.3rem;
}
.determineBtn {
  width: 100%;
  height: 0.82rem;
  line-height: 0.82rem;
  background: #00ae7e;
  border-radius: 4px;
  margin: 0 auto;
  text-align: center;
  font-weight: 400;
  float: left;
  color: rgba(255, 255, 255, 1);
  font-size: 0.3rem;
}
/* .btn {
  width: 50%;
  height: 0.82rem;
  background: #00ae7e;
  border-radius: 4px;
  margin: 0 auto;
  text-align: center;
  font-weight: 400;
  float: left;
  color: rgba(255, 255, 255, 1);
  font-size: 0.3rem;
} */
.btn {
	width: 94%;
	height: 0.82rem;
	line-height: 0.82rem;
	background: #00ae7e;
	border-radius: 4px;
	margin: 0 auto;
	margin-top: 0.15rem;
	text-align: center;
	font-weight: 400;
	color: rgba(255, 255, 255, 1);
	font-size: 0.3rem;
}
.btnDev {
  overflow: hidden;
  position: absolute;
  left: 0;
  bottom: 0;
}
.main .titleDiv {
  display: block;
  color: #333;
  font-size: 0.36rem;
  margin: 0.14rem 0;
}
.main .inputs {
  width: 100%;
  border: none;
  background: #f8f8f8;
  border: 1px solid #eeeeee;
  padding-left: 0.1rem;
  font-size: 0.28rem;
  height: 0.78rem;
}
.tips {
  line-height: 0.8rem;
  font-size: 0.3rem;
  font-weight: 800;
  text-align: center;
}
.tipsSuccess {
  line-height: 0.8rem;
  font-size: 0.3rem;
  font-weight: 800;
  text-align: center;
  color: #fa533d;
}
.tipsFail {
  font-size: 0.3rem;
  font-weight: 800;
  text-align: center;
  color: #fa533d;
  padding: 0.2rem 0;
}
</style>
